import * as yup from "yup";

export const homeClaimPersonalInfoForm = yup.object().shape({
  email: yup.string().required("This field is required."),
  name: yup.string(),
  phoneNumber: yup.string()
});
